import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import BaiduMap from 'vue-baidu-map';
import AlarmPush from "./alarmPush";
import { mapList, distributionData, stateData } from '@/api/deviceOverview/powerStation';
export default {
  name: 'omCenter',
  components: {
    AlarmPush: AlarmPush
  },
  data: function data() {
    return {
      dataList: {},
      buttonType: 'hide',
      //显示或隐藏按钮类型
      buttonLabel: this.$t('omcenter.hideDevName'),
      map: null,
      arr: [],
      contactData: [],
      provinceList: [],
      info: {},
      moreList: [],
      showMore: false
    };
  },
  mounted: function mounted() {
    this.showMap();
    this.showDistributionData();
    this.showStateData();
  },
  created: function created() {},
  methods: {
    seeMore: function seeMore(obj) {
      // this.$store.dispatch('SetDefaultStationFun', obj).then(res => {
      // })
      // .catch(() => {});
      this.$router.push({
        path: '/comlpexManage/fileManage',
        query: {
          id: obj.projectName
        }
      });
    },
    // 显示或隐藏配电站名称按钮
    buttonChange: function buttonChange() {
      var markers = this.map.getOverlays();

      if (this.buttonType == 'hide') {
        this.buttonType = 'show';
        this.buttonLabel = this.$t('omcenter.showDevName'); // 隐藏文字标签

        for (var i = 0; i < markers.length; i++) {
          if (markers[i].toString() == "[object Marker]") {
            //调用getLabel()前需判断overlays类型
            markers[i].getLabel().hide();
          }
        }
      } else {
        this.buttonType = 'hide';
        this.buttonLabel = this.$t('omcenter.hideDevName'); // 显示文字标签

        for (var i = 0; i < markers.length; i++) {
          if (markers[i].toString() == "[object Marker]") {
            markers[i].getLabel().show();
          }
        }
      }
    },
    drawBarChart: function drawBarChart(id, options) {
      console.log(options, 'optionss-');
      var myChart = echarts.init(document.getElementById(id)); // 使用 aidState做填充，fakeState显示小线条

      myChart.showLoading({
        text: this.$t('alarmData.loading') + '...'
      });
      myChart.hideLoading();
      myChart.setOption(options, window.onresize = myChart.resize);
    },
    // 调用接口
    // 显示地图
    showMap: function showMap() {
      var _this2 = this;

      var _this = this;

      mapList().then(function (res) {
        console.log(res);

        if (res.data.code !== 200) {
          _this2.$message.error(res.data.msg);

          return;
        }

        var data = res.data.data;
        data.map(function (item) {
          if (item.location) {
            item.location = JSON.parse(item.location);
          } // item.location.lat = item.location.lat.toString().slice(0,7)
          // item.location.lon = item.location.lon.toString().slice(0,8)

        });
        var arr = [];
        data.map(function (item) {
          var obj = {};

          if (item.location) {
            obj = item.location;
          }

          if (item.onlineFlag) {
            obj.onlineFlag = item.onlineFlag;
          }

          var filterIndex = arr.findIndex(function (item) {
            // console.log(item, obj,'item--obj')
            return item.lat == obj.lat && item.lon == obj.lon;
          }); // console.log(filterIndex)&& filterIndex == -1

          if (!obj.list) {
            obj.list = [];
            obj.list.push(item);
          } else {
            arr[filterIndex].list.push(item);
          }

          arr.push(obj);
        });
        _this2.arr = arr;
        var contactData = [],
            defaultMore = [];

        _this2.arr.forEach(function (item) {
          // console.log(item,'itemitem')
          var itemlat = '';
          var itemlon = '';

          if (item.lat) {
            itemlat = item.lat.toString().slice(0, 7);
          }

          if (item.lon) {
            itemlon = item.lon.toString().slice(0, 8);
          } // let itemlon = item.lon.toString().slice(0,8)


          var findIndex = -1;
          findIndex = contactData.findIndex(function (key) {
            return key.lat == itemlat && key.lon == itemlon;
          });
          defaultMore.push(item.list[0]);

          if (!contactData.length) {
            contactData.push({
              lat: itemlat,
              lon: itemlon,
              list: [item.list[0]]
            });
          } else if (findIndex > -1) {
            contactData[findIndex].list.push(item.list[0]);
          } else {
            contactData.push({
              lat: itemlat,
              lon: itemlon,
              list: [item.list[0]]
            });
          }
        });

        _this2.contactData = contactData;

        if (defaultMore.length) {
          _this2.showMore = true;
          _this2.moreList = defaultMore;
        }

        console.log(_this2.arr, defaultMore, ' this.arry');
        _this2.map = new BMap.Map("map"); // 创建Map实例

        _this2.map.reset();

        _this2.map.centerAndZoom(new BMap.Point(_this2.arr[0].lon, _this2.arr[0].lat), 8); // 初始化地图,设置中心点坐标和地图级别


        _this2.map.enableScrollWheelZoom(true); //启用滚轮放大缩小


        _this2.map.setCurrentCity(_this2.$t('omcenter.inChina')); // 设置地图显示的城市 此项是必须设置的


        var clusterMarkers = [];
        var markers = [];
        var pt = null;

        var _loop = function _loop(i) {
          if (!_this2.arr[i].list) {
            return "continue";
          }

          point = new BMap.Point(_this2.arr[i].lon, _this2.arr[i].lat);
          var index = _this2.arr[i].onlineFlag * 1;
          myIcon = new BMap.Icon(require('@/assets/img/map_icon1.png'), new BMap.Size(47, 49));
          marker = new BMap.Marker(point, {
            icon: myIcon
          }); // 创建标注

          markers.push(marker);
          label = new BMap.Label(_this2.arr[i].list.length, {
            offset: new BMap.Size(40, 8)
          });
          marker.addEventListener("click", function (e) {
            console.log(e, 'sss');

            _this.showDivBox(_this.arr[i]);
          });
          label.setStyle({
            lineHeight: "25px",
            height: "23px",
            color: "white",
            borderRadius: "5px",
            padding: "0 5px",
            background: "RGBA(255, 131, 85, 1)"
          });
        };

        for (var i = 0; i < _this2.arr.length; i++) {
          var point;
          var myIcon;
          var marker;
          var label;

          var _ret = _loop(i);

          if (_ret === "continue") continue;
        }

        var markerClusterer = new BMapLib.MarkerClusterer(_this2.map, {
          markers: markers
        });
      });
    },
    showDivBox: function showDivBox(obj) {
      console.log(obj, '---');
      this.showMore = true;
      this.moreList = [];
      var ary = [];
      var findIndex = -1;
      var itemlat = '';
      var itemlon = '';

      if (obj.lat) {
        itemlat = obj.lat.toString().slice(0, 7);
      }

      if (obj.lon) {
        itemlon = obj.lon.toString().slice(0, 8);
      } // let itemlat =obj.lat.toString().slice(0,7)
      // let itemlon =obj.lon.toString().slice(0,8)


      findIndex = this.contactData.findIndex(function (key) {
        return key.lat == itemlat && key.lon == itemlon;
      });
      console.log(findIndex, '===');
      this.moreList = this.contactData[findIndex].list;
    },
    // 显示各地城市分布
    showDistributionData: function showDistributionData() {
      var _this3 = this;

      distributionData().then(function (res) {
        console.log(res);

        if (res.data.code === 200) {
          _this3.provinceList = res.data.data;
          var xAxisAry = [],
              serialAry = [];

          for (var i = 0; i < _this3.provinceList.length; i++) {
            xAxisAry.push(_this3.provinceList[i].province);
            serialAry.push(_this3.provinceList[i].projectCount);
          }

          var options = {
            title: {
              subtext: _this3.$t('omcenter.devPlace')
            },
            color: '#6395f9',
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            legend: {},
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: {
              type: 'value',
              boundaryGap: [0, 0.01]
            },
            yAxis: {
              type: 'category',
              data: xAxisAry,
              minInterval: 1
            },
            series: [{
              name: '',
              type: 'bar',
              barWidth: 15,
              data: serialAry
            }]
          };

          _this3.drawBarChart('echartCity', options);
        } else {
          _this3.$message.error(res.data.msg);

          return;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    // 显示右侧工具栏数据
    showStateData: function showStateData() {
      var _this4 = this;

      stateData().then(function (res) {
        console.log(res);

        if (res.data.code === 200) {
          _this4.info = res.data.data;
        } else {
          _this4.$message.error(res.data.msg);

          return;
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
};